var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H25C30.5228 35 35 30.5228 35 25V10C35 4.47715 30.5228 0 25 0Z",
    fill: "#FA8B94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6066 20.5355L20.6777 13.4645",
    stroke: "#FA8B94",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6777 20.5355L13.6066 13.4645",
    stroke: "#FA8B94",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesBackground);
export default __webpack_public_path__ + "static/media/times-background.dee245b9158096e9f21168a8f5c29ccb.svg";
export { ForwardRef as ReactComponent };